import { useTranslation } from 'next-i18next';
import { FC, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { usePreAuthDrawCtx } from '../../../providers/PreAuthDrawProvider';
import { drawEntryActions } from '../store/draw-entry';
import { CryptoCom } from './review/CryptoCom';

export const CryptoComStep: FC = () => {
  const { t } = useTranslation('product');
  const { draw, entryIntentResponse } = usePreAuthDrawCtx();
  const dispatch = useDispatch();

  const handleApprove = useCallback(() => {
    if (draw?.id && entryIntentResponse.intent?.id) {
      // Handle successful setup intent
      dispatch(
        drawEntryActions.setupDrawEntry({
          actionId: draw.id,
          drawEntryIntentId: entryIntentResponse.intent.id,
          polling: true,
          freshEntry: true,
          entering: true,
          entered: false,
        }),
      );
    }
  }, [dispatch, draw, entryIntentResponse]);

  return (
    <div className="flex flex-col space-y-6">
      <p className="whitespace-pre-line">
        {t('drawers.review.draw.paymentMethod.cryptoCom.explainer')}
      </p>
      <div className="flex w-full justify-center">
        <CryptoCom
          onApprove={handleApprove}
          paymentID={entryIntentResponse.cryptoComPaymentId || ''}
        />
      </div>
    </div>
  );
};
